import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { Button, Modal, Checkbox } from 'app/components';
import { CaretUp , CaretDown , Verified , Ticket} from '@phosphor-icons/react';
import useLoginModal from '../../login/useLoginModal';
import './style';
import { getTicketDetails, postGetInTouchAnalytics } from '../api';
import { Avatar } from '../../user-profile/components';
import { analyticEventLogger } from '../../../utils/commonUtils';
import { GET_IN_TOUCH_EVENT_LOG } from '../../../constants/eventLogger';
import mixpanel from 'mixpanel-browser';

const TicketContainer = ({ ticketInfo, eventData, cat, handleOpen,isOpen, onToggle }) => {
  const [showModal, setShowModal] = useState(false);
  const [checked, setChecked] = useState(false);
  const loginModal = useLoginModal();

  const { userData } = useSelector((state) => state.app);

  function formatDate(dateString) {
    const date = new Date(dateString);

    // Check if the date is valid
    if (isNaN(date.getTime())) {
      return '';
    }

    // Define formatting options
    const options = {
      month: 'short',
      day: 'numeric',
    };

    // Format the date
    const formattedDate = new Intl.DateTimeFormat('en-US', options).format(
      date,
    );

    return formattedDate;
  }

  const onClickGetInTouch = (e) => {
    e.stopPropagation();
    if (!userData?.email) {
      loginModal.onOpen();
      loginModal.callback.current = () => {
        handleOpen(cat);
        getTicketDetails(eventData?._id, cat?.categoryName, () => {
          setShowModal(true);
        });
      }
    } else {
      mixpanel.track("Get_in_Touch_Clicked", {
        "event_id": eventData?._id,                 
        "event_name": eventData?.name,              
        "category_name": ticketInfo?.ticketCategoryName,       
        "seller_name": ticketInfo?.user?.name,           
        "seller_id": ticketInfo?.user?._id,               
        "whatsapp_url": `https://api.whatsapp.com/send?phone=${ticketInfo?.user?.mobile}`, 
        "user_id": userData?._id || "Anonymous",     
        "page_url": window.location.href,    
      });

      setShowModal(true);
    }
  };

  const onGetInTouch = () => {
    setShowModal(false);
    setChecked(!checked);
    postGetInTouchAnalytics(ticketInfo?._id);
    const userAgent = window.navigator.userAgent.toLowerCase();
    const mobileAgents = /iphone|ipad|android/;
    let isMobile = mobileAgents.test(userAgent);

    let { user, ticketCategoryName } = ticketInfo;
    
    analyticEventLogger(GET_IN_TOUCH_EVENT_LOG, {
      button_name: 'Get_In_Touch',
      isMobile: isMobile,
    });

    let whatsappurl = '';
    if (isMobile) {
      whatsappurl = `https://wa.me/91${user?.mobile}?text=Hi%20${user?.name}%2C%0AI%20found%20your%20listing%20for%20*${ticketCategoryName}%20tickets%20to%20${eventData?.name}*%20on%20Take%20My%20Tickets%2C%20and%20I’m%20interested%20in%20buying%20it.%0A%0ALooking%20forward%20to%20your%20response.%20Thanks!%20✌%EF%B8%8F`;
      window.open(whatsappurl);
    } else {
      whatsappurl = `https://web.whatsapp.com/send?phone=${user?.mobile}&text=Hi%20${user?.name}%2C%0AI%20found%20your%20listing%20for%20*${ticketCategoryName}%20tickets%20to%20${eventData?.name}*%20on%20Take%20My%20Tickets%2C%20and%20I’m%20interested%20in%20buying%20it.%0A%0ALooking%20forward%20to%20your%20response.%20Thanks!%20✌%EF%B8%8F`;
      window.open(whatsappurl, '_blank');
    }

    mixpanel.track("WhatsApp_Conversation_Initiated", {
      "event_id": eventData?._id,                 
      "event_name": eventData?.name,              
      "category_name": ticketInfo?.ticketCategoryName,       
      "seller_name": ticketInfo?.user?.name,
      "seller_id": ticketInfo?.user?._id,                
      "user_id": userData?._id || "Anonymous",     
      "whatsapp_url": window.location.href,
    });

  };

  return (
    <>
      <div
        className="p-6 flex flex-col gap-6 bd-1 bg-[#fff] cursor-pointer active"
        onClick={onToggle}
        id={ticketInfo?._id}
      >
        <div className="flex gap-3 justify-center items-center">
          {ticketInfo?.user?.picture ? (
            <img
              src={ticketInfo?.user?.picture}
              alt="Profile Picture"
              className="ticketProfile"
            />
          ) : (
            <Avatar name={ticketInfo?.user?.name}
              className="ticket-avatar" />
          )}
          <div className="flex flex-col gap-1 ">
            <h1 className="heading-16 md:heading-24 ticketCardHeading">
              {ticketInfo?.tickets} ticket
            </h1>
            <p className="text-14 md:text-16">{ticketInfo?.ticketCategoryName}</p>
          </div>
          <div className="flex flex-col items-end ml-auto">
            <p className="text-[#009D64] label-16">
              ₹ {ticketInfo?.ticketPrice}
            </p>
            <p className="text-black text-14 md:text-16">per ticket</p>
          </div>
          {!isOpen ? (
            <CaretDown className="cursor-pointer"
              size={20}
              fill="#B7B7B7" />
          ) : (
            <CaretUp className="cursor-pointer"
              size={20}
              fill="#B7B7B7" />
          )}
        </div>

        {isOpen && (
          <>
            <hr />
            <div className="flex flex-col gap-3">
              <div className="flex flex-3 gap-3">
                <h1 className="heading-16 hd">{ticketInfo?.user?.name}</h1>
                <p className="text-16 hd ml-auto">
                  (Listed on {formatDate(ticketInfo?.createdAt)})
                </p>
              </div>
              <div className="flex gap-4">
                <div className="flex gap-1">
                  <img src="/assets/images/verified.svg" />
                  <p className="text-14 md:text-16">User verified</p>
                </div>
                <div className="flex gap-1">
                  <img src="/assets/images/verified.svg" />
                  <p className="text-14 md:text-16">Tickets verified</p>
                </div>
              </div>
            </div>
            <Button
              className="w-full"
              iconRight={<img src="/assets/images/wp.svg" />}
              onClick={onClickGetInTouch}
            >
              Get in touch
            </Button>
          </>
        )}
      </div>
      <Modal
        isOpen={showModal}
        hasClose
        className="confirm-modal"
        size="regular"
        title="Say no to screenshots! ✨"
        onClose={() => {
          setShowModal(false);
        }}
      >
        <div className="flex gap-[10px] px-3 py-4 items-center bg-[#FFF2F2] rounded-xl">
          <Ticket size={64}
            fill="#FF2459" />
          <p className="text-14">
            Kindly ask the sellers to transfer the tickets to either your email
            ID or phone number.
            <a href="https://linktr.ee/take_my_tickets"
              target="_blank"
              className="text-[#FF2459] underline cursor-pointer">
              Learn how to get your tickets transferred.
            </a>
          </p>
        </div>

        <div className="flex gap-[10px] px-3 py-4 items-start">
          <Checkbox
            checked={checked}
            className={`${checked && 'chk-active'}`}
            onClick={() => setChecked(!checked)}
          />
          <p className="text-14">
            I acknowledge and accept the{' '}
            <a href="/terms-and-conditions"
              target="_blank"
              className="font-medium underline cursor-pointer">
              Terms of service
            </a>{' '}
            and{' '}
            <a className="font-medium underline cursor-pointer"
              href="/privacy-policy"
              target="_blank">
              Privacy policy.
            </a>{' '}
            I confirm to transfer tickets to the buyer upon payment;
            non-compliance may result in legal action.
          </p>
        </div>
        <Button disabled={!checked}
          className="w-full"
          onClick={onGetInTouch}>
          Get in touch
        </Button>
      </Modal>
    </>
  );
};

export default TicketContainer;